import SalesOrderApi from "./SalesOrderApi"

export default SalesOrderApi